const pathBase = `/system/staff_profile_statistics/`;

export const staffProfileStatistics = {
  get: () => pathBase,
};
